import { ReportParameters } from 'generated/graphql-types';
import { ParameterFormValueBase } from '../report-parameter-list/models/report-parameter-form-value';
import { StringReportParameterValue } from './string-report-parameter-value';

export function createTimeZoneReportParameter(value?: TimeZoneReportParameterValue): TimeZoneReportParameterValue {
   const date = new Date();
   let timeZone: string | null = date.getTimezoneOffset().toString();

   if (value?.value) {
      timeZone = value.value;
   }

   return {
      value: timeZone,
   };
}

export interface TimeZoneReportParameterValue {
   value?: string | null;
}

export interface TimeZoneParameterFormModel extends ParameterFormValueBase, StringReportParameterValue {
   parameterType: ReportParameters.TimeZone;
}

export const defaultTimeZoneParameter: TimeZoneReportParameterValue = {
   value: null,
};
